import { Component, Input, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ResourceVm } from 'qp-ui-interface';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DataService } from 'src/app/data.service';
import { SubscriptionAction } from '../../enums/subscription';
import { DialogService } from '../../services/dialog.service';
import { UserEntitlementService } from '../../services/evergent/entitlement/user-entitlement.service';
import { GenericAhaGoldPromptComponent } from '../aha-upgrade-prompts/generic/generic-aha-gold-prompt/generic-aha-gold-prompt.component';
import { NewrelicService } from 'src/app/analytics/newrelic/services/newrelic.service';
import { AppEventName } from 'src/app/analytics/newrelic/enums/EventName';
import { NewrelicAppStore } from 'src/app/analytics/newrelic/store/newrelicApp.store';
import { ClevertapService } from 'src/app/analytics/clevertap/service/clevertap.service';
import { ClevertapEvent } from 'src/app/analytics/clevertap/enum/clevertap.eventType';

@Component({
  selector: 'app-in-app-banner',
  templateUrl: './in-app-banner.component.html',
  styleUrls: ['./in-app-banner.component.scss'],
})
export class InAppBannerComponent implements OnInit {
  @Input() resource: ResourceVm;
  @Input() bannerAspectRatio: string = '8x1';
  @Input() verticalIndex: number = 0;
  @Input() index: number = 0;
  imageLoaded: boolean = false;

  private destroy$ = new Subject<void>();
  showPlanAction: SubscriptionAction | null = null;

  getClassName(): string {
    return `in-app-banner-${this.bannerAspectRatio}`;
  }

  constructor(
    private readonly dataService: DataService,
    private readonly router: Router,
    private readonly userEntitlementService: UserEntitlementService,
    private readonly dialogService: DialogService,
    private readonly newrelic: NewrelicService,
    private readonly newrelicAppStore: NewrelicAppStore,
    private readonly clevertapService: ClevertapService
  ) {}

  ngOnInit(): void {
    this.userEntitlementService.planActionBtn$
      .pipe(takeUntil(this.destroy$))
      .subscribe((action) => {
        this.showPlanAction = action;
      });
  }

  onFocus() {
    this.dataService.horizontalIndex = this.index;
    this.dataService.verticalIndex = this.verticalIndex;
    this.dataService.selectedCardData = this.resource;
  }

  onClick() {
    this.newrelic.sendAppEvent(AppEventName.IN_APP_BANNER_CLICK, {
      ...this.newrelicAppStore.getInAppBannerClickInfo(),
    });
    // this.clevertapService.addEvent(ClevertapEvent.BANNER_AD_CLICK);
    if (this.showPlanAction === SubscriptionAction.UPGRADE) {
      this.dataService.emitVerticalMenuEvent({
        action: 'close',
      });
      this.dialogService.openDialog(GenericAhaGoldPromptComponent, {
        data: {
          redirectFrom: 'vertical-menu',
        },
      });
    } else {
      this.router.navigate([`/plans`]);
    }
  }

  onImageLoad() {
    this.imageLoaded = true;
  }


  getImageWidth() {

    const vwValue = 9;
    const pxValue = (window.innerWidth * vwValue) / 100;
    const totalWidth = window.innerWidth - pxValue;
    return `${totalWidth}px`;
  }

  getImageHeight() {

    const width = Number(this.getImageWidth());
    const aspectRatio = 8 / 1;
    const height = (width / aspectRatio).toFixed(2);
    return `${height}px`;
  }
}
